<template>
	<div>
		<v-toolbar
		dark
		fixed
		app
		height="50"
		class="toolBar"
		v-if="Object.keys(columnName).length>0"
		>
		<v-spacer></v-spacer>

		<v-toolbar-items>
			<v-icon class="white--text" @click="downloadWithCSS('Monthly-Progress-Report')">cloud_download</v-icon>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<v-icon class="white--text" @click="printdiv">print</v-icon>

			<!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
			<!-- <v-icon class="white--text" @click="processingVal">print</v-icon> -->
			<!-- <v-icon class="white--text" @click="getData">print</v-icon> -->
			
		</v-toolbar-items>
	</v-toolbar>

<!-- {{items}}
<br><br>
{{subItems}} -->

<v-container grid-list-md :class="{opacityC:isTrue}">
      <v-layout wrap>
        <v-flex xs10 offset-xs1>
          <div style="background:#FFF; padding:20px;">
			<div ref="content" id="print_div">
				
				<!-- {{Object.keys(thValue[0]).length}} -->
				<!-- {{Object.keys(columnName).length}} -->
				<!-- {{columnName}}
				<br>
				{{store}} -->

				<table class="reportTbl" width="100%" id="tblData" v-if="store.length>0" >
					<tbody>
						<tr class="tb-td">
							<td :colspan="Object.keys(columnName).length + 4" class="textclass">
								{{project_name}}
							</td>
						</tr>
						<tr class="tb-td">
							<td :colspan="Object.keys(columnName).length + 4">
								{{credit_name}}
							</td>
						</tr>
						<tr class="tb-td">
							<td :colspan="Object.keys(columnName).length + 4">
								&nbsp;
							</td>
						</tr>

						<tr class="txtCenter colName">
							<td colspan="2">Package Name</td>		
							<td v-for="(n,key) in columnName">
								{{key}}
							</td>
							<td>Total</td>					
						</tr>


						<tr class="txtCenter" v-for="(item, key) in store" v-if="key==0">
							<td 
							:rowspan="store.length" 
							style="background: #FFEBEE;"
							>
							{{PackageName}}
							</td>
							<td>
								{{store[key]['step_name']}}
							</td>

							<td v-for="(n,k) in Object.keys(columnName).length"
							:class="[
							store[key][Object.keys(columnName)[k]] == 1 ? tdBgColor :'']"
							>								
								{{
									(store[key][Object.keys(columnName)[k]]) ? store[key][Object.keys(columnName)[k]] : 0
								}}							
							</td>

							<td class="totalTdBg">
								{{store[key]['Total']}}
							</td>
												
						</tr>

						<tr class="txtCenter" v-for="(item, key) in store" v-if="key > 0 ">
							<td>
								{{store[key]['step_name']}}
							</td>

							<td v-for="(n,k) in Object.keys(columnName).length"
							:class="[
							store[key][Object.keys(columnName)[k]] == 1 ? tdBgColor :'']"
							>								
								{{
									(store[key][Object.keys(columnName)[k]]) ? store[key][Object.keys(columnName)[k]] : 0
								}}							
							</td>
							
							<td class="totalTdBg">
								{{store[key]['Total']}}
							</td>
						</tr>
	
					</tbody>
				</table>
			</div>
		</div>
        </v-flex>
      </v-layout>
    </v-container> 

		
	</div>
</template>
<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas"
const commonService = require("../../../services/common.service");
export default {
	props:['paramVal'],
	data: () => ({
				
		subItems:[],
		isTrue:false,

		tdBgColor:'tdBgColor',
		totalTdBg:'totalTdBg',

		mainQueryData: [],
		
		project_name:'',
		credit_name:'',
		PackageName:'',
		store:[],
		thValue:[],
		columnName:{},
		
	}),

	created(){		
		//console.log('created');
		this.getData();		
	},

	watch: {
        paramVal() {
        	this.getData();
        }
    },

	methods: {

		getName: function(stpName) {
			var i;
			if (stpName) {								
				this.store.forEach(function(x, index) {				
					if (x.step_name == stpName) {
						i = index;				 		
					}		
				});
			}
			return i;
		},

		processingVal(){

			let root = this
			this.store = [];

			
			var obj = {};
			var obj2 = {};
			var f = [];
			let data = this.mainQueryData;
			var sum = 0;

			for(var i = 0; i < data.length; i++) {
				obj = {}
				obj2 = {}

				if(i == 0){
					root.PackageName = data[i]["name"];
					root.project_name = data[i]["project_name"];
					root.credit_name = data[i]["credit_name"];
				}
				root.columnName[data[i]["Months"]] = 0;
					
				sum = sum+data[i]["VALUE"];
				obj[data[i]["Months"]] = data[i]["VALUE"];
				obj['step_name'] = data[i]["step_name"];
				obj['Total'] = sum;
				sum = 0;

				var d = this.getName(data[i]["step_name"]);
				if(typeof d != 'undefined')
				{
					obj2[data[i]["Months"]] = data[i]["VALUE"];
					obj2['Total'] = root.store[d].Total + data[i]["VALUE"];
					Object.assign(root.store[d], obj2)
				}
				else
				{
					root.store.push(obj);
				}				
			}
		},

		getData(){

			let root = this;
			let formSchema = '';
			let p = this.paramVal;
			
			if(typeof p == "undefined")
			{
				this.isTrue = false;
				formSchema = JSON.parse(sessionStorage.getItem('report'));
			}
			else
			{
				this.isTrue = true;
				formSchema = this.paramVal;
			}
			
			/*let formSchema = {
				'project_id': 1,
				'report_type': 1,
			}*/

			commonService.dataByMulParameters(formSchema, "procurement-report").then(res => {
				//console.log('res', res);
				if(res.mainQueryData.length>0)
				{

					this.mainQueryData = res.mainQueryData
					this.processingVal();
					
					if(formSchema.report_type == 0)
					{	
						setTimeout(function(){							
							root.exportTableToExcel('tblData', 'Procurement-Report');
						},1000);							
					}					
				}


			});
		},

		downloadWithCSS(filename='') {			
			const doc = new jsPDF({
				orientation: "a4",
		        // unit: "pt",
		        format: [740, 1000]
		    });
			/** WITH CSS */
			var canvasElement = document.createElement('canvas');
			html2canvas(this.$refs.content, { canvas: canvasElement }).then(function (canvas) {
				const img = canvas.toDataURL("image/jpeg", 0.8);
				
				//doc.addImage(img,'JPEG',0,20);
				doc.addImage(img,'JPEG',10,10);

				filename = filename?filename+'.pdf':'pdf-file.pdf';

				doc.save(filename);
				//window.open(filename)
			});
		},

		exportTableToExcel: function(tableID, filename = ''){
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename?filename+'.xls':'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if(navigator.msSaveOrOpenBlob){
				var blob = new Blob(['\ufeff', tableHTML], {
					type: dataType
				});
				navigator.msSaveOrOpenBlob( blob, filename);
			}else{
			// Create a link to the file
			downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

			// Setting the file name
			downloadLink.download = filename;

			//triggering the function
			downloadLink.click();
		}		
	},

	printdiv: function () {
                this.printContentStatus = true;
                const divToPrint = document.getElementById("print_div");
                this.printContentStatus = false;
                const newWin = window.open("", "Print-Window");
                newWin.document.open();
                newWin.document.write(
                    '<style type="text/css">'+
                    'table.reportTbl{width:100%;border-collapse:collapse}.reportTbl td{border:1px solid #ccc;padding:6px}.reportTbl tr td{text-align:left;line-height:15px}.txtRight{text-align:right!important}.reportTbl tr.txtCenter td{text-align:center}.reportTbl tr.tb-td td{font-weight:700;text-align:center;border:none}td.textCenter{text-align:center!important}td.textRight{text-align:right !important}'+
                    "</style>"
                );
                newWin.document.write(
                    '<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
                    divToPrint.innerHTML +
                    "</body></html>"
                );

                newWin.document.close();
                setTimeout(function () {
                    newWin.close();
                }, 10);
            },

}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table.reportTbl{
	width:100%;
	border-collapse: collapse;
}
.reportTbl td{
	border:1px solid #CCC;
	padding: 6px;
}
.reportTbl tr td{	
	text-align:left;
	line-height: 15px;
}
.txtRight{	
	text-align:right !important;
}
.reportTbl tr.txtCenter td{	
	text-align:center;
}
.reportTbl tr.tb-td td{
	font-weight: bold;
	text-align:center;
	border:none;
}
td.textCenter{
	text-align: center !important;
}
td.textRight{
	text-align: right !important;
}
.subTable tr td{
	/*text-align: center !important;*/
}
</style>


// WEBPACK FOOTER //
// src/components/reportGenerate/pdf/procurementReport.vue